import { handlers } from './handlers'
import { env, isDevelopment } from '../../config/env'

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined'

// Setup MSW based on environment
export async function setupMocks() {
  // Only use browser worker in browser environment
  if (isBrowser && isDevelopment() && env.ENABLE_MOCKS) {
    // Dynamic import for browser environment (development)
    const { setupWorker } = await import('msw/browser')
    const worker = setupWorker(...handlers)

    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
    })

    return {
      start: () => worker.start(),
      stop: () => worker.stop(),
      reset: () => worker.resetHandlers(),
    }
  }

  // Return no-op functions if mocks are disabled or not in browser
  return {
    start: () => Promise.resolve(),
    stop: () => Promise.resolve(),
    reset: () => {},
  }
}
